<template>
	<el-menu class="navbar" mode="horizontal">
		<logo-title class="nav-logo"></logo-title>
		<div class="right-menu" v-show="name && face">
			<el-badge :value="message.unread_count" :max="999" :hidden="!message.unread_count" class="message" :style="{
				'padding-right': !!message ? '10px' : 0
			}">
				<!-- <router-link to="/message"><svg-icon icon-class="message"></svg-icon> 消息</router-link> -->
				<el-dropdown trigger="click" placement="bottom" @visible-change="changeVisible">
					<div style="cursor: pointer;"><svg-icon icon-class="message"></svg-icon> 消息</div>
					<el-dropdown-menu slot="dropdown">
							<router-link v-for="item in message.notice_info" :key="item.type" :to="{path: '/message/' + item.type, query: {trigger: 'nav'}}">
								<el-dropdown-item>
									<div  style="width: 80px;":style="redStatus ? {display: 'flex'} : ''">
										<div style="width: 100%;" :class="{textCenter: !redStatus}">{{item.desc}}</div>
										<el-badge v-if="item.red_point_cnt" style="width: 30px;margin-top: 5px;height: 12px;" :value="item.red_point_cnt" :max="999" class="item"></el-badge>
									</div>
								</el-dropdown-item>
							</router-link>
							<!-- <router-link to="/charts/flow">
								<el-dropdown-item>修改密码</el-dropdown-item>
							</router-link> -->
						</el-dropdown-menu>
					</el-dropdown>
			</el-badge>
			<el-dropdown trigger="click" placement="bottom">
				<div class="username">
					<user-face class="face"></user-face>
					{{ name }}
					<i class="el-icon-caret-bottom"></i>
				</div>
				<el-dropdown-menu slot="dropdown">
					<router-link to="/accountdetail">
						<el-dropdown-item>账号设置</el-dropdown-item>
					</router-link>
					<!-- <router-link to="/charts/flow">
						<el-dropdown-item>修改密码</el-dropdown-item>
					</router-link> -->
					<el-dropdown-item>
						<span @click="logout" style="display:block;">退出登录</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Hamburger from '@/components/Hamburger'
import LogoTitle from '@/components/LogoTitle'
import UserFace from '@/components/UserFace'

export default {
	components: {
		Hamburger,
		LogoTitle,
		UserFace
	},
	data() {
		return {
			redStatus: false
		}
	},
	computed: {
		...mapGetters([
			'name', 'face', 'message'
		])
	},
	watch: {
		message(val) {
			this.redStatus = false;
			val.notice_info.forEach(item => {
				if (item.red_point_cnt) {
					this.redStatus = true;
				}
			})
		}
	},
	methods: {
		logout() {
			this.$store.dispatch('logOut').then(() => {
				this.$router.push({ path: '/login' })
				// location.reload() // In order to re-instantiate the vue-router object to avoid bugs
			})
		},
		changeVisible(e) {
			if (e) {
				// 获取未读数
			}
		},
	}
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

$bg: #282828;
$height: 64px;

.navbar {
	position: fixed;
	z-index: 1;
	width: 100%;
	height: $height;
	line-height: $height;
	border-bottom: 0;
	background: $bg;
	color: $white;
	.nav-logo {
		margin-left: 30px;
		float: left;
	}
	.right-menu {
		position: absolute;
		right: 0;
		top: 0;
		height: 100%;
		&:focus{
			outline: none;
		}
		.message {
			width: auto;
			height: 20px;
			line-height: 20px;
			font-size: 14px;
			margin-right: 40px;
			padding-right: 10px;
			a {
				color: $white;
				&:hover {
					color: $yellow;
				}
			}
		}
		.username {
			padding-right: 30px;
			.face {
				float: left;
				width: 32px;
				height: 32px;
				margin: 16px 12px 0 0;
				border-radius: 100%;
			}
		}
		.el-dropdown {
			color: $white;
		}
	}
}
.textCenter {
	text-align: center;
}
</style>
